import List from "../../containers/DealTypes/List";
import Entry from "../../containers/DealTypes";

const DealTypeRoutes = [
  {
    path: "/deal-types",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/deal-types/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/deal-types/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default DealTypeRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/dealTypes.jsx